module.exports = __webpack_public_path__ + "img/AD-HANOI_6.cc1c75cf.jpg";